import {
  Paper, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Skeleton
} from '@mui/material';

const UnsoldProductsTable = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        ❌ Productos sin ventas este mes
      </Typography>

      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <TableContainer sx={{ maxHeight: 300, overflow: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Producto</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((prod, idx) => (
                <TableRow key={idx}>
                  <TableCell>{prod.product}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default UnsoldProductsTable;
